module.exports = __webpack_public_path__ + "static/media/profileimage.003388a1.svg";